import { i18n } from 'core/i18n';

import { recordLinkV2 } from 'utilities/tagging';
import {
    CLICK_GO_TO_ACCOUNTS_LINK_EVENT,
    DISPLAY_ERROR_EVENT,
    DISPLAY_SUCCESS_EVENT,
    FLOW_ERROR_STEP_TAGGING,
    FLOW_STEP1_TAGGING,
    FLOW_STEP2_TAGGING,
    FLOW_SUCCESS_STEP_TAGGING,
    STEP_DESCRIPTION,
    STEP_EVENT_NAME,
    TEALIUM,
} from '../constants/tagging';
import { MOTIVE_SELECT_BETTER_OFFERS_OPTION, 
    MOTIVE_SELECT_ERRORS_OPTION, 
    MOTIVE_SELECT_INACTIVE_OPTION, 
    MOTIVE_SELECT_OTHER_ACCOUNTS_OPTION, 
    MOTIVE_SELECT_OTHER_OPTION, 
    MOTIVE_SELECT_PERSONAL_OPTION 
} from '../constants';

const { formatText } = i18n;

const getTaggingPageName = (visibleStep) => {
    return "/cancelAccount/step" + visibleStep + "/" + STEP_DESCRIPTION[visibleStep];
};

export const getTaggingWizard = (immAccount, immAccountCancel) => {
    return {
        ...TEALIUM,
        event_name: STEP_EVENT_NAME[immAccountCancel.get('currentStep')],
        pageName: getTaggingPageName(immAccountCancel.get('currentStep')),
        processStep: `step${immAccountCancel.get('currentStep')}`,
        processDetail: STEP_DESCRIPTION[immAccountCancel.get('currentStep')],
        productName: `${immAccount.get('newProduct')}.${immAccount.get('accountType')}`,
    }
};

const REASON_VALUE_TO_TAGGING_MAP = {
    [MOTIVE_SELECT_PERSONAL_OPTION]: "personalReasons",
    [MOTIVE_SELECT_OTHER_ACCOUNTS_OPTION]: "otherAccounts",
    [MOTIVE_SELECT_ERRORS_OPTION]: "errors",
    [MOTIVE_SELECT_BETTER_OFFERS_OPTION]: "betterOffer",
    [MOTIVE_SELECT_OTHER_OPTION]: "otherReasons",
    [MOTIVE_SELECT_INACTIVE_OPTION]: "notUse"
}

export const taggingOpenMotiveDropdownEvent = (immAccountCancel) => {
    recordLinkV2({
        ...FLOW_STEP1_TAGGING.OPEN_MOTIVE_DROPDOWN_EVENT,
        eventCategory: getTaggingPageName(immAccountCancel.get('currentStep')),
    })
};

export const taggingCloseMotiveDropdownEvent = (immAccountCancel) => {
    recordLinkV2({
        ...FLOW_STEP1_TAGGING.CLOSE_MOTIVE_DROPDOWN_EVENT,
        eventCategory: getTaggingPageName(immAccountCancel.get('currentStep')),
    })
};

export const taggingSelectMotiveDropdownEvent = (immAccountCancel, motive) => {
    recordLinkV2({
        ...FLOW_STEP1_TAGGING.SELECT_MOTIVE_EVENT,
        eventCategory: getTaggingPageName(immAccountCancel.get('currentStep')),
        element: REASON_VALUE_TO_TAGGING_MAP[motive],
        eventLabel: REASON_VALUE_TO_TAGGING_MAP[motive],
    })
};

export const taggingMotiveInputClickedEvent = (immAccountCancel) => {
    recordLinkV2({
        ...FLOW_STEP1_TAGGING.CLICK_MOTIVE_INPUT_EVENT,
        eventCategory: getTaggingPageName(immAccountCancel.get('currentStep')),
    });
}

export const taggingPersonalDataLinkClickEvent = (immAccountCancel) => {
    recordLinkV2({
        ...FLOW_STEP2_TAGGING.CLICK_PERSONAL_DATA_LINK_EVENT,
        eventCategory: getTaggingPageName(immAccountCancel.get('currentStep')),
    });
}

export const getTaggingSuccessStep = (immAccount) => {
    return {
        ...TEALIUM,
        ...FLOW_SUCCESS_STEP_TAGGING[DISPLAY_SUCCESS_EVENT],
        productName: `${immAccount.get('newProduct')}.${immAccount.get('accountType')}`,
    }
}

export const taggingSuccessStepRedirect = (pathname) => {
    recordLinkV2({
        ...FLOW_SUCCESS_STEP_TAGGING[CLICK_GO_TO_ACCOUNTS_LINK_EVENT],
        pathname,
        eventCategory: window.utag_data.nombrePagina,
    })
}

export const getTaggingErrorStep = (immAccount) => {
    return {
        ...FLOW_ERROR_STEP_TAGGING[DISPLAY_ERROR_EVENT],
        productName: `${immAccount.get('newProduct')}.${immAccount.get('accountType')}`,
        errorDescription: formatText("cancellation_account-account_cancellation_request_error_description")
    }
}

export const taggingErrorStepRedirect = () => {
    recordLinkV2({
        ...FLOW_ERROR_STEP_TAGGING[CLICK_GO_TO_ACCOUNTS_LINK_EVENT],
        eventCategory: window.utag_data.nombrePagina,
    })
}
